export enum LiberSaveFrontend {
    AUTH = 'auth',
    MC = 'mc',
    CC = 'cc',
    CP = 'cp',
    LP = 'lp',
}
